const useLocalBillingHost = require("./use-local-billing-host");
const staticResourceHost = process.env.appConfig.billing["static-resource.host"].replace("{ticket}", process.env.appConfig["featureTicket"]);

export const billingHost = useLocalBillingHost ? `https://${process.env.HOST}:3002` : staticResourceHost;
